import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class PartnershipM2TaxService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveM2TaxAmounts(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData || !data?.colData?.map) return of({ callSuccess: '0', errorMessage: 'Invalid payload' });
    const row = data.rowData;
    const jsonObj = [{
      combination_key: row.COMBINATION_KEY,
      trans_sub_type: row[`${data.colData.map}_TRANS_TYPE`],
      amount: row[data.colData.map]
    }];
    const jsonSettings = [{
      tax_year: filterParams?.tax_year,
      group_trans_key: row.GROUP_TRANS_KEY
    }];
    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      jsonObj: JSON.stringify(jsonObj),
      jsonSettings: JSON.stringify(jsonSettings)
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=qttpro`,
      params,
      globalService,
      filterParams
    );
  }
}
